import type { PortalData } from '../generated/api';
import config from '../config';

const PORTAL_DATA_KEY = 'portal-data';
const TTL = 1000 * 60 * 60 * 24 * 15; //15 days

type StoredPortalData = PortalData & { exp: number };

function get<T extends Boolean>(
  withExp: T,
): (true extends T ? StoredPortalData : PortalData) | undefined {
  const item = localStorage.getItem(PORTAL_DATA_KEY);
  if (!item) {
    return;
  }
  try {
    const parsed = JSON.parse(item) as StoredPortalData;
    if (!parsed.exp) {
      return;
    }
    return parsed;
  } catch (e) {
    return undefined;
  }
}

function now() {
  return new Date().getTime();
}

async function warm() {
  console.log('WARMING UP portal-data');
  const current = get(true);
  if (current && current.exp >= now()) {
    console.log('CACHE-HIT', current);
    return current;
  }

  console.log('CACHE-MISS');
  const url = `${config.PROTOCOL}://${config.API_URL}/api/portal-data`;
  let data: PortalData;

  try {
    data = await (await fetch(url)).json();
  } catch (err) {
    console.log('WARMUP failed');
    return;
  }

  const exp = now() + TTL;
  localStorage.setItem(PORTAL_DATA_KEY, JSON.stringify({ ...data, exp }));
  console.log('SAVING', data);
  return data;
}

(window as any).careand_warmup = warm();

export const getPortalData = get;
